export default "__VITE_ASSET__CcYzpTHO__"